import { render } from "./AllXDetails.vue?vue&type=template&id=76d4f7c7"
import script from "./AllXDetails.vue?vue&type=script&lang=js"
export * from "./AllXDetails.vue?vue&type=script&lang=js"

import "./AllXDetails.vue?vue&type=style&index=0&id=76d4f7c7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__